import HeroSection from "@/components/public/home/HeroSection";
import StatsStrip from "@/components/public/home/StatsStrip";
import ServicesTimeline from "@/components/public/home/ServicesTimeline";
import FlagshipsTimeline from "@/components/public/home/FlagshipsTimeline";
import ProcessWithVideos from "@/components/public/home/ProcessWithVideos";
import BlogTimeline from "@/components/public/home/BlogTimeline";
import AboutTrbd from "@/components/public/home/AboutTrbd";
import FounderSection from "@/components/public/home/FounderSection";
import MegaCTA from "@/components/public/home/MegaCTA";

const Home = () => {
    return (
        <div className="flex flex-col">
            <HeroSection />
            <StatsStrip />
            <ServicesTimeline />
            <FlagshipsTimeline />
            <ProcessWithVideos />
            <BlogTimeline />
            <AboutTrbd />
            <FounderSection />
            <MegaCTA />
        </div>
    );
};

export default Home;
